import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ar from 'vuetify/es5/locale/ar'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark : true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1E496C',
        secondary: '#013B6C',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#707070',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#1E496C',
        secondary: '#2A72A1',
        accent: '#82B1FF',
        error: '#980724',
        info: '#707070',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#FFFFFF'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  locales: {ar},
  current: 'en'
});
